import styled from 'styled-components';
import media from '../../styled/media';

export const H3 = styled.h3`
  font-size: 24px;
  line-height: 36px;
  margin: 24px 0;
  font-weight: 400;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const Intro = styled.div`
  text-align: center;
  background: url('/images/how-it-works/intro-xs.jpg') #f2f2f2 no-repeat center;
  background-size: cover;
  ${media.tablet`
    height: 664px;
    text-align: initial;
    background-image: url('/images/how-it-works/intro.jpg');
  `}
`;

export const IntroInner = styled.div`
  height: 488px;
  padding: 40px 20px;
  ${media.tablet`
    height: 664px;
    display: flex;
    align-items: center;
  `}
`;

export const IntroText = styled.p`
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
    max-width: 50%;
  `}
`;

export const Sizing = styled.div`
  text-align: center;
  padding: 40px 0;
  ${media.tablet`
    padding: 80px 0;
  `}
`;

export const SizingItems = styled.ul`
  ${media.tablet`
    display: flex;
    margin-top: 80px;
  `}
`;

export const SizingItem = styled.li`
  ${media.tablet`
    flex: 1;
    padding: 0 16px;
  `}
`;

export const Features = styled.div`
  background: #f5f5f5;
  padding: 20px 0;
  ${media.tablet`
    padding: 80px 0;
  `}
  ${H3} {
    text-align: center;
    ${media.tablet`
      text-align: inherit;
    `}
  }
`;

export const FeaturesInner = styled.div`
  ${media.tablet`
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  `}
`;

export const FeaturesCell = styled.div`
  padding: 20px 0;
  ${media.tablet`
    width: 50%;
    padding: 0 20px;
  `}
`;

export const Benefits = styled.div`
  padding: 20px 0;
  ${media.tablet`
    padding: 80px 0;
  `}
  ${H3} {
    text-align: center;
    ${media.tablet`
      text-align: inherit;
    `}
  }
`;

export const BenefitsInner = styled.div`
  ${media.tablet`
    display: flex;
    align-items: center;
  `}
`;

export const BenefitsCell = styled.div`
  padding: 20px 0;
  ${media.tablet`
    width: 50%;
    padding: 0;
    &:first-child {
      padding-right: 56px;
    }
  `}
`;

export const Integrations = styled.div`
  background: #f5f5f5;
  padding: 40px 0;
  text-align: center;
  ${media.tablet`
    padding: 80px 0;
  `}
`;

export const Omnichannel = styled.div`
  padding: 40px 0;
  text-align: center;
  ${media.tablet`
    padding: 80px 0;
  `}
`;

export const OmnichannelItemTitle = styled.p`
  color: #cb2027;
  font-size: 24px;
  line-height: 33px;
`;

export const Demo = styled.div`
  background: url('/images/how-it-works/demo.jpg') no-repeat center;
  background-size: auto;
  ${media.tablet`
    background-size: contain;
  `}
`;

export const DemoInner = styled.div`
  padding: 40px 0;
  height: 580px;
  text-align: center;
  ${media.tablet`
    text-align: initial;
    height: 624px;
    display: flex;
    align-items: center;
  `}
`;

export const Ul = styled.ul`
  list-style-image: url('/images/how-it-works/checkmark.svg');
  li {
    margin: 12px 0 12px 22px;
    ${media.tablet`
      padding-left: 10px;
    `}
  }
`;

export const IntegrationsItems = styled.ul`
  ${media.tablet`
    display: flex;
    margin-top: 80px;
  `}
`;

export const IntegrationsItem = styled.li`
  ${media.tablet`
    flex: 1;
    padding: 0 16px;
  `}
`;
